import { SearchParams } from "@STRSERVICE/optima-react-components";
import { atom, selector } from "recoil";
import { get as httpGet } from "services/httpService";
import { Broadcast } from "types/broadcast";
import { PagedResponse, RequestError } from "types/request";
import { API_URL_COM } from "utils/constants";

// The broadcast list filters on unReadOnly; it ignores "unread", the conversation list's name for it.
type BroadcastSearchParams = SearchParams & {
  unReadOnly: boolean;
};

export const broadcastStateUpdated = atom<number>({
  key: "broadcastStateUpdated",
  default: 0,
});

export const broadcastsSelector = selector({
  key: "broadcastsSelector",
  get: async ({ get }) => {
    // Refresh the broadcasts state
    get(broadcastStateUpdated);

    const search: BroadcastSearchParams = {
      search: "",
      page: 0,
      size: 50,
      order: "desc",
      unReadOnly: true, // Should always filter on unread broadcasts
    };

    const query = new URLSearchParams(search as unknown as URLSearchParams);
    // v2 returns the list wrapped in a paged body instead of a bare array (the v1 route is retired).
    // httpGet resolves with a RequestError on failure (null on 204) rather than throwing; those
    // pass through unchanged, as they did before.
    const response: PagedResponse<Broadcast> | RequestError | null = await httpGet(
      `${API_URL_COM}v2/broadcasts?${query.toString()}`
    );
    const broadcasts = (response && "items" in response ? response.items : response) as Broadcast[];

    return broadcasts;
  },
});
